/**
 * 三欄式頁面佈局容器
 * 用於首頁、收藏、搜尋、貼文詳情、世界觀詳情等共用相同佈局結構的頁面
 *
 * 斷點行為：
 *   <992px (md-)  : 1 欄（main only，置中，max 634px）
 *   992-1199 (lg) : 2 欄（left flex:1 min:286 + main 634）
 *   ≥1200 (xl+)  : 3 欄（left flex:1 min:286 + main 634 + right flex:1）
 */
import PropTypes from 'prop-types';
import MainNav from '@/components/layout/AppNavbar';
import Loading from '@/components/ui/Loading';

const PageLayout = ({
  leftSidebar,
  rightSidebar,
  children,
  isLoading = false
}) => {
  return (
    <>
      <MainNav />
      <main className="container-lg nav-padding home-page">
        <div className="d-flex flex-column flex-lg-row gap-3 align-items-lg-start pt-lg-3">
          {leftSidebar && (
            <aside className="page-layout-left d-none d-lg-block position-sticky side-section">
              {leftSidebar}
            </aside>
          )}
          <section className="page-layout-main mx-auto mx-lg-0">
            {children}
          </section>
          {rightSidebar && (
            <aside className="page-layout-right d-none d-xl-block position-sticky side-section">
              {rightSidebar}
            </aside>
          )}
        </div>
      </main>
      {isLoading && <Loading />}
    </>
  );
};

PageLayout.propTypes = {
  leftSidebar: PropTypes.node,
  rightSidebar: PropTypes.node,
  children: PropTypes.node,
  isLoading: PropTypes.bool
};

export default PageLayout;
